import React from 'react';
import KeycloakSingleton from '../../../../features/Auth/utils/keycloakSingleton';
import { useTranslation } from 'react-i18next';

export default function MaxUsersReached() {
    const { t } = useTranslation();
    const customGreen = "#69d945";
    const customGreenHover = "#5bc73a";

    const reset = () => {
        const keycloak = KeycloakSingleton.getInstance();
        keycloak.logout();
    };

    const mediaStyles = `
.msg-cnx {
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;    
  min-height: 100vh;       
  padding: 2rem;
  text-align: center;
}

    .msg-cnx h2 {
      margin: 0.5rem 0;
    }

    .primary-btn {
      margin-top: 2rem;
      padding: 0.75rem 1.5rem;
      background-color: ${customGreen};
      color: white;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;
      font-size: 1rem;
      transition: all 0.3s ease;
    }

    .primary-btn:hover {
      background-color: ${customGreenHover};
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(105, 217, 69, 0.3);
    }
  `;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: mediaStyles }} />
            <div className='msg-cnx'>
                <h2>{t('max_users_reached')}</h2>
                <h2>{t('contact_admin')}</h2>

                <button className="primary-btn" onClick={reset}>
                    {t('Réinitialiser')}
                </button>
            </div>
        </>
    );
}
